import React from "react";
import { Container, Row } from "reactstrap";

//Import Section Title
import SectionTitle from "../common/section-title";
import SurahSection from "./SurahSection";
import Spinner from "../Spinner/Spinner";

const SurahListComponent = ({ sectionClass, surahList, isLoading, sectionTitle, sectionDesc, printable=false }) => {

  return (
    <React.Fragment>
      <section className={"section " + sectionClass} id="services">
        <Container>
          {/* section title */}
          <SectionTitle
            title={sectionTitle}
            desc={sectionDesc}
          />

          <Row className="mt-1">
            {
              isLoading ? <div className="spinner-overlay"><Spinner /></div> :
              <SurahSection services={surahList} printable={printable} />
            }
          </Row>

        </Container>
      </section>
    </React.Fragment>
  );
};

export default SurahListComponent;
